import variableApi from '@/api/variable';
import rawVariableApi from '@/api/rawVariables';
import aggregateVariableApi from '@/api/aggregateVariables';
import aggregateVariableDefs from '@/layouts/variables/aggregateVariableDefs';

const SET_VARIABLES = 'SET_VARIABLES';
const SET_RAW_VARIABLES = 'SET_RAW_VARIABLES';
const UPDATE_RAW_VARIABLE = 'UPDATE_RAW_VARIABLE';
const SET_AGGREGATE_VARIABLES = 'SET_AGGREGATE_VARIABLES';
const ADD_AGGREGATE_VARIABLE = 'ADD_AGGREGATE_VARIABLE';
const UPDATE_AGGREGATE_VARIABLE = 'UPDATE_AGGREGATE_VARIABLE';
const DELETE_AGGREGATE_VARIABLE = 'DELETE_AGGREGATE_VARIABLE';

const state = {
  variables: [],
  variablesTimestamp: 0,
  rawVariables: [],
  rawVariablesTimestamp: 0,
  aggregateVariables: [],
  aggregateVariablesTimestamp: 0
};

const getters = {
  getVariables: state => {
    return state.variables;
  },
  getRawVariables: state => {
    return state.rawVariables;
  },
  getAggregateVariables: state => {
    return state.aggregateVariables;
  },
  getAggregateOperatedVariables: state => {
    return state.aggregateVariables.filter(variable => variable.goal === aggregateVariableDefs.goal.operated);
  },
  getAggregateGradualVariables: state => {
    return state.aggregateVariables.filter(variable => variable.goal === aggregateVariableDefs.goal.gradual);
  },
  getAggregateMetricalVariables: state => {
    return state.aggregateVariables.filter(variable => variable.goal === aggregateVariableDefs.goal.metrical);
  }
};

const mutations = {
  [SET_VARIABLES] (state, variables) {
    state.variables = variables;
    state.variablesTimestamp = new Date().getTime();
  },
  [SET_RAW_VARIABLES] (state, rawVariables) {
    state.rawVariables = rawVariables;
    state.rawVariablesTimestamp = new Date().getTime();
  },
  [UPDATE_RAW_VARIABLE] (state, rawVariable) {
    const index = state.rawVariables.map(e => e.id).indexOf(rawVariable.id);
    state.rawVariables.splice(index, 1, rawVariable);
  },
  [SET_AGGREGATE_VARIABLES] (state, aggregateVariables) {
    state.aggregateVariables = aggregateVariables;
    state.aggregateVariablesTimestamp = new Date().getTime();
  },
  [ADD_AGGREGATE_VARIABLE] (state, aggregateVariable) {
    state.aggregateVariables.push(aggregateVariable);
  },
  [UPDATE_AGGREGATE_VARIABLE] (state, aggregateVariable) {
    const aggregateVariablesIndex = state.aggregateVariables.map(e => e.id).indexOf(aggregateVariable.id);
    state.aggregateVariables.splice(aggregateVariablesIndex, 1, aggregateVariable);

    const variablesIndex = state.variables.map(e => e.value.id).indexOf(aggregateVariable.id);
    state.variables.splice(variablesIndex, 1, {
      label: aggregateVariable.name,
      value: aggregateVariable
    });
  },
  [DELETE_AGGREGATE_VARIABLE] (state, id) {
    const aggregateVariablesIndex = state.aggregateVariables.map(e => e.id).indexOf(id);
    state.aggregateVariables.splice(aggregateVariablesIndex, 1);

    const variablesIndex = state.variables.map(e => e.value.id).indexOf(id);
    state.variables.splice(variablesIndex, 1);
  }
};

const actions = {
  retrieveVariables ({ state, commit }, { context }) {
    return new Promise((resolve, reject) => {
      variableApi.getVariables(context).then(data => {
        commit(SET_VARIABLES, data);
        resolve();
      }, error => {
        reject(error);
      });
    });
  },
  retrieveVariablesForced ({ state, commit }, { context }) {
    return new Promise((resolve, reject) => {
      variableApi.getVariables(context).then(data => {
        commit(SET_VARIABLES, data);
        resolve();
      }, error => {
        reject(error);
      });
    });
  },
  retrieveRawVariables ({ commit }, { context }) {
    rawVariableApi.getRawVariables(context).then(data => {
      commit(SET_RAW_VARIABLES, data);
    });
  },
  updateRawVariable ({ commit }, { context, rawVariable }) {
    return new Promise((resolve, reject) => {
      rawVariableApi.updateRawVariable(context, rawVariable)
        .then(data => {
          commit(UPDATE_RAW_VARIABLE, data);
          resolve();
        }, error => {
          reject(error);
        });
    });
  },
  retrieveAggregateVariables ({ state, commit }, { context }) {
    aggregateVariableApi.getAggregateVariables(context).then(data => {
      commit(SET_AGGREGATE_VARIABLES, data);
    });
  },
  createAggregateVariable ({commit}, {context, aggregateVariable}) {
    return new Promise((resolve, reject) => {
      aggregateVariableApi.createAggregateVariable(context, aggregateVariable)
        .then(data => {
          commit(ADD_AGGREGATE_VARIABLE, data);
          resolve();
        }, error => {
          reject(error);
        });
    });
  },
  updateAggregateVariable ({ commit }, { context, aggregateVariable }) {
    return new Promise((resolve, reject) => {
      aggregateVariableApi.updateAggregateVariable(context, aggregateVariable)
        .then(data => {
          commit(UPDATE_AGGREGATE_VARIABLE, data);
          resolve();
        }, error => {
          reject(error);
        });
    });
  },
  deleteAggregateVariable ({ commit }, { context, id }) {
    return new Promise((resolve, reject) => {
      aggregateVariableApi.deleteAggregateVariable(context, id)
        .then(() => {
          commit(DELETE_AGGREGATE_VARIABLE, id);
          resolve();
        }, error => {
          reject(error);
        });
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/variable/index.js